import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import Refresh from '../../../components/Refresh';
import {
  restClient
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import CreateComponent from './Create';
import EditComponent from './Edit';
import Header from './Header';

class List extends Component {

  getTitle() {
    return 'Колцентры';
  }

  render() {
    const defaultValues = {companies_list: [], };
    const create = (handleSubmit) => <CreateComponent onSubmit={handleSubmit} record={defaultValues} companies={this.props.companies} />;
    const edit = (handleSubmit, record) => <EditComponent onSubmit={handleSubmit} record={record} companies={this.props.companies} />;

    return (
      <div className="col-wrapper">
        <EjectedList
          {...this.props}
          title={this.getTitle()}
          sort={{ field: '_createdAt', order: SORT_DESC }}
          perPage={100}
          actions={<Refresh />}
          bulkActions={false}
          style={{ width: '900px' }}
          headercomponent={Header}
          companies={this.props.companies}
        >
          <CustomerDatagrid
            edit={edit}
            create={create}
            companies={this.props.companies}
          />
        </EjectedList>
      </div>
    );
  }
}

export default connect(state => ({
  companies: state.sc.companies,
}), {})(List);



// WEBPACK FOOTER //
// ./src/pages/admin/callcenter/List.js